import { datadogRum } from '@datadog/browser-rum';
import { dashboardDatadogRum } from './window';

/**
 * Utility to get the correct Datadog RUM instance depending on which app is the
 * host application. Datadog RUM must be a window singleton to function properly.
 */
export function getDatadogRum() {
  const rum = dashboardDatadogRum();
  if (rum) {
    return rum;
  }
  return datadogRum;
}